<template>
  <div>
    <div class="card">
      <div class="card-header">
        <strong>Address</strong>
        <div class="card-collapse">Collapse</div>
      </div>
      <div class="card-body form-horizontal">
        <div class="row">
          <div class="col-12">
            <div class="card-block">
              <div class="form-group row">
                <label for="country" class="col-md-2">Country</label>
                <div class="col-md-10">
                  <input
                    id="country"
                    v-model="entity.address.address.country"
                    type="text"
                    placeholder="Enter Country"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="state" class="col-md-2">State</label>
                <div class="col-md-10">
                  <input
                    id="state"
                    v-model="entity.address.address.state"
                    type="text"
                    placeholder="Enter State"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="city" class="col-md-2">City</label>
                <div class="col-md-10">
                  <input
                    id="city"
                    v-model="entity.address.address.city"
                    type="text"
                    placeholder="Enter City"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="zip" class="col-md-2">Zip code</label>
                <div class="col-md-10">
                  <input
                    id="zip"
                    v-model="entity.address.address.zip"
                    type="text"
                    placeholder="Enter Zip code"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="streetAddress1" class="col-md-2">Street Address 1</label>
                <div class="col-md-10">
                  <input
                    id="streetAddress1"
                    v-model="entity.address.address.street1"
                    type="text"
                    placeholder="Enter Street Address"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="streetAddress2" class="col-md-2">Street Address 2</label>
                <div class="col-md-10">
                  <input
                    id="streetAddress2"
                    v-model="entity.address.address.street2"
                    type="text"
                    placeholder="Enter Street Address"
                    class="form-control"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <strong>Mail Address</strong>
        <div class="card-collapse">Collapse</div>
      </div>
      <div class="card-body form-horizontal collapse">
        <div class="row">
          <div class="col-12">
            <div class="card-block">
              <div class="form-group row">
                <label for="mailCountry" class="col-md-2">Country</label>
                <div class="col-md-10">
                  <input
                    id="mailCountry"
                    v-model="entity.address.mail_address.country"
                    type="text"
                    placeholder="Enter Country"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="mailState" class="col-md-2">State</label>
                <div class="col-md-10">
                  <input
                    id="mailState"
                    v-model="entity.address.mail_address.state"
                    type="text"
                    placeholder="Enter State"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="mailCity" class="col-md-2">City</label>
                <div class="col-md-10">
                  <input
                    id="mailCity"
                    v-model="entity.address.mail_address.city"
                    type="text"
                    placeholder="Enter City"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="mailZip" class="col-md-2">Zip code</label>
                <div class="col-md-10">
                  <input
                    id="mailZip"
                    v-model="entity.address.mail_address.zip"
                    type="text"
                    placeholder="Enter Zip code"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="mailStreetAddress1" class="col-md-2">Street Address 1</label>
                <div class="col-md-10">
                  <input
                    id="mailStreetAddress1"
                    v-model="entity.address.mail_address.street1"
                    type="text"
                    placeholder="Enter Street Address"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="mailStreetAddress2" class="col-md-2">Street Address 2</label>
                <div class="col-md-10">
                  <input
                    id="mailStreetAddress2"
                    v-model="entity.address.mail_address.street2"
                    type="text"
                    placeholder="Enter Street Address"
                    class="form-control"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <strong>Alternative Address</strong>
        <div class="card-collapse">Collapse</div>
      </div>
      <div class="card-body form-horizontal collapse">
        <div class="row">
          <div class="col-12">
            <div class="card-block">
              <div class="form-group row">
                <label for="altCountry" class="col-md-2">Country</label>
                <div class="col-md-10">
                  <input
                    id="altCountry"
                    v-model="entity.address.alt_address.country"
                    type="text"
                    placeholder="Enter Country"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="altState" class="col-md-2">State</label>
                <div class="col-md-10">
                  <input
                    id="altState"
                    v-model="entity.address.alt_address.state"
                    type="text"
                    placeholder="Enter State"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="altCity" class="col-md-2">City</label>
                <div class="col-md-10">
                  <input
                    id="altCity"
                    v-model="entity.address.alt_address.city"
                    type="text"
                    placeholder="Enter City"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="altZip" class="col-md-2">Zip code</label>
                <div class="col-md-10">
                  <input
                    id="altZip"
                    v-model="entity.address.alt_address.zip"
                    type="text"
                    placeholder="Enter Zip code"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="altStreetAddress1" class="col-md-2">Street Address 1</label>
                <div class="col-md-10">
                  <input
                    id="altStreetAddress1"
                    v-model="entity.address.alt_address.street1"
                    type="text"
                    placeholder="Enter Street Address"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="altStreetAddress2" class="col-md-2">Street Address 2</label>
                <div class="col-md-10">
                  <input
                    id="altStreetAddress2"
                    v-model="entity.address.alt_address.street2"
                    type="text"
                    placeholder="Enter Street Address"
                    class="form-control"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <strong>Contact info</strong>
        <div class="card-collapse">Collapse</div>
      </div>
      <div class="card-body form-horizontal">
        <div class="row">
          <div class="col-12">
            <div class="card-block">
              <div class="form-group row">
                <label for="director" class="col-md-2">Director</label>
                <div class="col-md-10">
                  <input
                    id="director"
                    v-model="entity.contacts.director_name"
                    type="text"
                    placeholder="Enter Director Name"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="phone" class="col-md-2">Phone</label>
                <div class="col-md-5">
                  <input
                    id="phone"
                    v-model="entity.contacts.phone1"
                    type="text"
                    placeholder="Enter Phone"
                    class="form-control"
                  >
                </div>
                <div class="col-md-5">
                  <input
                    id="phone2"
                    v-model="entity.contacts.phone2"
                    type="text"
                    placeholder="Enter Phone 2"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="fax" class="col-md-2">Fax</label>
                <div class="col-md-5">
                  <input
                    id="fax"
                    v-model="entity.contacts.fax1"
                    type="text"
                    placeholder="Enter Fax"
                    class="form-control"
                  >
                </div>
                <div class="col-md-5">
                  <input
                    id="fax2"
                    v-model="entity.contacts.fax2"
                    type="text"
                    placeholder="Enter Fax 2"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="officeEmail" class="col-md-2">Email</label>
                <div class="col-md-5">
                  <input
                    id="officeEmail"
                    v-model="entity.contacts.email1"
                    type="text"
                    placeholder="Enter Email"
                    class="form-control"
                  >
                </div>
                <div class="col-md-5">
                  <input
                    id="officeEmail2"
                    v-model="entity.contacts.email2"
                    type="text"
                    placeholder="Enter Email 2"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="website" class="col-md-2">Website</label>
                <div class="col-md-10">
                  <input
                    id="website"
                    v-model="entity.contacts.website"
                    type="text"
                    placeholder="Enter Website"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="directorEmail" class="col-md-2">Director Email</label>
                <div class="col-md-10">
                  <input
                    id="directorEmail"
                    v-model="entity.contacts.director_email"
                    type="text"
                    placeholder="Enter Director Email"
                    class="form-control"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <strong>Location</strong>
        <div class="card-collapse">Collapse</div>
      </div>
      <div class="card-body form-horizontal">
        <div class="row">
          <div class="col-12">
            <div class="card-block">
              <div class="form-group row">
                <label for="googleLink" class="col-md-2">Google Maps link</label>
                <div class="col-md-10">
                  <input
                    id="googleLink"
                    v-model="entity.location.gmap_link"
                    type="text"
                    placeholder="Enter Google Maps link"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label for="googleLink" class="col-md-2">Google Direction link</label>
                <div class="col-md-10">
                  <input
                    id="googleDirectionLink"
                    v-model="entity.location.direction_link"
                    type="text"
                    placeholder="Enter Google Direction link"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-2">Geocode</label>
                <div class="col-md-5" style="margin-bottom: 1rem;">
                  <input v-model="entity.location.lat" type="text" placeholder="Enter latitude" class="form-control">
                </div>
                <div class="col-md-5">
                  <input v-model="entity.location.lng" type="text" placeholder="Enter longitude" class="form-control">
                </div>
                <div class="col-md-10 offset-md-2">
                  <gmap-map
                    v-if="entity.location"
                    style="width: 100%; height:350px; margin-top: 20px;"
                    :center="sourceMapData.center"
                    :zoom="sourceMapData.zoom"
                    @click="mapClick"
                  >
                    <gmap-marker v-if="entity.location.lat && entity.location.lng" :position="entityMapCenter" />
                  </gmap-map>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Save Button -->
    <div class="mb-5">
      <button class="btn btn-success" @click="save">
        Save
        <span class="btn-loader" style="display: none;" />
      </button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    source: {
      type: Object,
      default() {
        return {};
      },
    },
    entity: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    sourceMapData() {
      if (this.source.location === undefined
        || this.source.location.lat == null
        || this.source.location.lng == null
      ) {
        return {
          center: {
            lat: 0,
            lng: 0,
          },
          zoom: 2,
        };
      }
      return {
        center: {
          lat: _.toNumber(this.source.location.lat),
          lng: _.toNumber(this.source.location.lng),
        },
        zoom: 13,
      };
    },
    entityMapCenter() {
      if (this.entity.location === undefined
        || this.entity.location.lat == null
        || this.entity.location.lng == null
      ) {
        return {
          lat: 0,
          lng: 0,
        };
      }
      return {
        lat: _.toNumber(this.entity.location.lat),
        lng: _.toNumber(this.entity.location.lng),
      };
    },
  },
  mounted() {
    this.initCollapse();
  },
  destroyed() {
    $(document).off('click', '.card-collapse');
  },
  methods: {
    mapClick(event) {
      this.entity.location.lat = event.latLng.lat();
      this.entity.location.lng = event.latLng.lng();
    },
    setOldGeocode() {
      this.entity.location.lat = this.source.location.lat;
      this.entity.location.lng = this.source.location.lng;
    },
    initCollapse() {
      $(document).on('click', '.card-collapse', function () {
        const $body = $(this).parents('.card').children('.card-body');
        if ($body.hasClass('collapse')) {
          $body.slideDown(function () {
            $(this).removeClass('collapse');
          });
        } else {
          $body.slideUp(function () {
            $(this).addClass('collapse');
          });
        }
      });
    },
    saveRequest() {
      const postFormData = new FormData();
      const faxes = [];
      const phones = [];
      const emails = [];
      postFormData.append('title', this.entity.title);
      postFormData.append('domain', this.entity.domain);
      postFormData.append('type', this.entity.type);
      postFormData.append('local_institution', this.entity.local_institution ? this.entity.local_institution : '');
      postFormData.append('library', this.entity.library ? this.entity.library : '');
      postFormData.append('address', JSON.stringify(this.entity.address.address));
      postFormData.append('mail_address', JSON.stringify(this.entity.address.mail_address));
      postFormData.append('alt_address', JSON.stringify(this.entity.address.alt_address));
      if (this.entity.contacts.phone1) phones.push(this.entity.contacts.phone1);
      if (this.entity.contacts.phone2) phones.push(this.entity.contacts.phone2);
      if (this.entity.contacts.fax1) faxes.push(this.entity.contacts.fax1);
      if (this.entity.contacts.fax2) faxes.push(this.entity.contacts.fax2);
      if (this.entity.contacts.email1) emails.push(this.entity.contacts.email1);
      if (this.entity.contacts.email2) emails.push(this.entity.contacts.email2);
      postFormData.append('contacts', JSON.stringify({
        director_name: this.entity.contacts.director_name,
        director_email: this.entity.contacts.director_email,
        phone: phones,
        fax: faxes,
        email: emails,
        website: this.entity.contacts.website,
      }));
      postFormData.append('location', JSON.stringify(this.entity.location));
      if (this.entity.description) {
        postFormData.append('description', this.entity.description);
      }
      postFormData.append('published', this.entity.published || false);
      postFormData.append('sections', JSON.stringify(this.entity.sections));
      postFormData.append('boxes', JSON.stringify(this.entity.boxes));
      return this.$apiHttp.post(`${this.$config.app_api.prefix}branch-offices/${this.$route.params.id}`,
        postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      this.saveRequest().then(() => {
        $('.btn-success .btn-loader').hide();
        this.$store.commit('notifications/setSuccessNotification', 'Success!');
      }).catch((error) => {
        this.$store.commit('notifications/setDangerNotification', 'Error!');
        console.error('Error in update branch office query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Contacts.vue?5a264388